export default __webpack_public_path__ + "static/media/bp-logo-white.cb7d8f85.png";